import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import options from "./options/options";

Vue.use(Vuex);

export default {
  state: {
    selectedPlaats: {},
    selectedPlaatsInputValue: "",
    selectedStraal: 0,
    selectedMinPrijs: 0,
    selectedMaxPrijs: 0,
    selectedMinWoonoppervlakte: 0,
    selectedMaxWoonoppervlakte: 0,
    selectedMinAantalKamers: 1,
    selectedSoortenWoning: [],
    selectedTypenWoning: [],
    selectedStatussen: [],
  },
  actions: {
    async postWonenObjecten(context) {
      await axios
        .post("/umbraco/api/WonenObjecten/PostWonenObjectenQuery", {
          actief: true,
          plaats: "",
          soortWoning: "",
          typeWoning: "",
          woonoppervlakteVan: "",
          woonoppervlakteTot: "",
          koopprijsVan: "",
          koopprijsTot: "",
          aantalKamers: "",
          status: "",
        })
        .then(function(response) {
          context.commit("dummyWonenObjecten", response.data.DummyWonenObjecten);
          context.commit("wonenObjectenDataReady", true);
        })
        .catch(function(error) {
          context.commit("wonenObjectenDataReady", true);
        });
    },
  },
  mutations: {
    selectedPlaats(state, payload) {
      state.selectedPlaats = payload;
    },
    selectedPlaatsInputValue(state, payload) {
      state.selectedPlaatsInputValue = payload;
    },
    selectedStraal(state, payload) {
      state.selectedStraal = payload;
    },
    selectedMinPrijs(state, payload) {
      state.selectedMinPrijs = payload;
    },
    selectedMaxPrijs(state, payload) {
      state.selectedMaxPrijs = payload;
    },
    selectedMinWoonoppervlakte(state, payload) {
      state.selectedMinWoonoppervlakte = payload;
    },
    selectedMaxWoonoppervlakte(state, payload) {
      state.selectedMaxWoonoppervlakte = payload;
    },
    selectedMinAantalKamers(state, payload) {
      state.selectedMinAantalKamers = payload;
    },
    selectedSoortenWoning(state, payload) {
      state.selectedSoortenWoning = payload;
    },
    selectedTypenWoning(state, payload) {
      state.selectedTypenWoning = payload;
    },
    selectedStatussen(state, payload) {
      state.selectedStatussen = payload;
    },
  },
  modules: {
    options: options,
  },
};
